var map = {
	"./Yellowtail-Regular.otf": "d2f5",
	"./educabinh_icon.png": "09bb",
	"./educabinh_icon_background.png": "adcb",
	"./educabinh_name.png": "88be",
	"./educabinh_name_background.png": "84df",
	"./feature_graphic_lessonb.png": "bcae",
	"./feature_graphic_scoredent.png": "71b5",
	"./icon_lessonb.png": "895d",
	"./icon_scoredent.png": "cb32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";